import React, { useState } from 'react';
import { Palette, Settings, DollarSign } from 'lucide-react';
import { SectionHeader, BasicSection, DesignSection, HardwareSection } from '@smartphone-tycoon/shared-ui';

export function Controls({
  name,
  setName,
  price,
  setPrice,
  color,
  setColor,
  material,
  setMaterial,
  buttonColor,
  setButtonColor,
  hasButtons,
  setHasButtons,
  screenBorderColor,
  setScreenBorderColor,
  cameraStyle,
  setCameraStyle,
  cameraColor,
  setCameraColor,
  cameraPosition,
  setCameraPosition,
  buttonPositions,
  setButtonPositions,
  phoneSize,
  setPhoneSize,
  screenSize,
  setScreenSize,
  cornerRadius,
  setCornerRadius,
  logo,
  setLogo,
  cpu,
  setCpu,
  gpu,
  setGpu,
  ram,
  setRam,
  storage,
  setStorage,
  network,
  setNetwork,
  os,
  setOs,
  camera,
  setCamera,
  battery,
  setBattery,
  gameDate,
  completedResearch,
  filteredMaterials,
  filteredComponents,
}) {
  const [activeSection, setActiveSection] = useState('basic');

  const getComponentSetter = (categoryId: string) => {
    const setters: { [key: string]: (value: string) => void } = {
      cpu: setCpu,
      gpu: setGpu,
      ram: setRam,
      storage: setStorage,
      network: setNetwork,
      os: setOs,
      camera: setCamera,
      battery: setBattery,
    };
    return setters[categoryId];
  };

  const getSelectedValue = (categoryId: string) => {
    const values: { [key: string]: string } = {
      cpu,
      gpu,
      ram,
      storage,
      network,
      os,
      camera,
      battery,
    };
    return values[categoryId];
  };

  return (
    <aside className="w-96 bg-theme-bg-content overflow-y-auto max-h-screen">
      <div className="p-4 space-y-6">
        {/* Basic Section */}
        <SectionHeader
          title="Basic Info"
          icon={<DollarSign className="w-5 h-5" />}
          isOpen={activeSection === 'basic'}
          onToggle={() => setActiveSection(activeSection === 'basic' ? '' : 'basic')}
        />
        <BasicSection
          name={name}
          setName={setName}
          price={price}
          setPrice={setPrice}
          isOpen={activeSection === 'basic'}
        />

        {/* Design Section */}
        <SectionHeader
          title="Design"
          icon={<Palette className="w-5 h-5" />}
          isOpen={activeSection === 'design'}
          onToggle={() => setActiveSection(activeSection === 'design' ? '' : 'design')}
        />
        <DesignSection
          isOpen={activeSection === 'design'}
          color={color}
          setColor={setColor}
          material={material}
          setMaterial={setMaterial}
          buttonColor={buttonColor}
          setButtonColor={setButtonColor}
          hasButtons={hasButtons}
          setHasButtons={setHasButtons}
          screenBorderColor={screenBorderColor}
          setScreenBorderColor={setScreenBorderColor}
          cameraStyle={cameraStyle}
          setCameraStyle={setCameraStyle}
          cameraColor={cameraColor}
          setCameraColor={setCameraColor}
          cameraPosition={cameraPosition}
          setCameraPosition={setCameraPosition}
          buttonPositions={buttonPositions}
          setButtonPositions={setButtonPositions}
          phoneSize={phoneSize}
          setPhoneSize={setPhoneSize}
          screenSize={screenSize}
          setScreenSize={setScreenSize}
          cornerRadius={cornerRadius}
          setCornerRadius={setCornerRadius}
          logo={logo}
          setLogo={setLogo}
          filteredMaterials={filteredMaterials}
        />

        {/* Hardware Section */}
        <SectionHeader
          title="Hardware"
          icon={<Settings className="w-5 h-5" />}
          isOpen={activeSection === 'hardware'}
          onToggle={() => setActiveSection(activeSection === 'hardware' ? '' : 'hardware')}
        />
        <HardwareSection
          isOpen={activeSection === 'hardware'}
          getComponentSetter={getComponentSetter}
          getSelectedValue={getSelectedValue}
          gameDate={gameDate}
          completedResearch={completedResearch}
          filteredComponents={filteredComponents}
        />
      </div>
    </aside>
  );
}